import React, { useEffect, useState } from "react";
import { getUserProfile, updateUserProfile, controllaInsulti } from "../../api";
import { Button } from "../../components/common/Button";

export const UserProfilePage: React.FC = () => {
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    first_name: "",
    last_name: "",
    password: "",
    confirmPassword: "",
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const fetchProfile = async () => {
      setError("");
      try {
        const profile = await getUserProfile();
        setFormData({
          ...formData,
          username: profile.username,
          email: profile.email,
          first_name: profile.first_name,
          last_name: profile.last_name,
          password: "",
          confirmPassword: "",
        });
      } catch (err) {
        setError("Errore nel caricamento del profilo");
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setSuccess(false);

    if (formData.password && formData.password !== formData.confirmPassword) {
      setError("Le password non coincidono");
      return;
    }

    if (controllaInsulti(formData.password)) {
      setError("La password non può contenere insultiall'FSM PORCA!!!");
      return;
    }
    if (controllaInsulti(formData.first_name) || controllaInsulti(formData.last_name)) {
      setError("Il nome o il cognome non possono contenere insultiall'FSM PORCA!!!");
      return;
    }
    if (controllaInsulti(formData.email)) {
      setError("L'email non può contenere insultiall'FSM PORCA!!!");
      return;
    }

    try {
      const profile = await updateUserProfile({
        username: formData.username,
        email: formData.email,
        first_name: formData.first_name,
        last_name: formData.last_name,
        ...(formData.password ? { password: formData.password } : {}), // invia solo se presente
      });
      setSuccess(true);
      setFormData({ ...formData, ...profile, password: "", confirmPassword: "" });
    } catch (err) {
      setError("Errore durante il salvataggio");
    }
  };

  if (loading) return <p>Caricamento...</p>;

  return (
    <div className="max-w-md mx-auto bg-white shadow-md rounded-xl p-6">
      <h2 className="text-xl font-bold mb-4">Profilo Utente</h2>

      {error && <p className="text-red-600 mb-2">{error}</p>}
      {success && <p className="text-green-600 mb-2">Profilo aggiornato!</p>}

      <form onSubmit={handleSubmit} className="space-y-6 max-w-md mx-auto">
        {/* Dati base */}
        <div className="space-y-4">
            <div>
            <label htmlFor="username" className="block text-sm font-medium text-gray-700">
                Username
            </label>
            <input
                id="username"
                name="username"
                type="text"
                value={formData.username}
                onChange={handleChange}
                placeholder="Inserisci username"
                className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
            />
            </div>

            <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Email
            </label>
            <input
                id="email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="esempio@email.com"
                className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
            />
            </div>

            <div>
            <label htmlFor="first_name" className="block text-sm font-medium text-gray-700">
                Nome
            </label>
            <input
                id="first_name"
                name="first_name"
                type="text"
                value={formData.first_name}
                onChange={handleChange}
                placeholder="Il tuo nome"
                className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
            />
            </div>

            <div>
            <label htmlFor="last_name" className="block text-sm font-medium text-gray-700">
                Cognome
            </label>
            <input
                id="last_name"
                name="last_name"
                type="text"
                value={formData.last_name}
                onChange={handleChange}
                placeholder="Il tuo cognome"
                className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
            />
            </div>
        </div>

        {/* Cambio password */}
        <div className="border-t pt-4 space-y-4">
            <p className="text-sm font-medium text-gray-700">Cambia password (opzionale)</p>

            <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                Nuova password
            </label>
            <input
                id="password"
                name="password"
                type="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Inserisci nuova password"
                className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
            />
            </div>

            <div>
            <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">
                Conferma nuova password
            </label>
            <input
                id="confirmPassword"
                name="confirmPassword"
                type="password"
                value={formData.confirmPassword}
                onChange={handleChange}
                placeholder="Ripeti la nuova password"
                className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
            />
            </div>
        </div>

        {/* Submit */}
        <Button type="submit" className="w-full">
            Salva modifiche
        </Button>
        </form>

    </div>
  );
};
